import {GetFiveStarsParams} from 'domain/usecases';
import {makeGetFiveStars} from 'main/factories/usecases';

export const getFiveStars = async ({signal}: GetFiveStarsParams) => {
	try {
		const response = await makeGetFiveStars().get({signal});
		const mappedEvaluations = response.items.map(item => ({
			data: item.values.data,
			tipo: item.keys.tipo,
			local: item.values.local,
			especialidade: item.values.especialidade,
		}));

		dataLayer.push({
			event: 'avaliacoes_atendimento',
			avaliacoes: mappedEvaluations,
		});

		return response;
	} catch (error) {
		return null;
	}
};
